var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArabic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7104 0H7.57422V4.66656H22.3107V1.6003C22.3107 0.716453 21.5943 0 20.7104 0Z",
    fill: "#73AF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57422 14.0001H20.7105C21.5943 14.0001 22.3108 13.2836 22.3108 12.3998V9.3335H7.57422V14.0001Z",
    fill: "#464655"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3108 4.66553H7.57446V9.33184H22.3108V4.66553Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54317 0C1.65932 0 0.942871 0.716453 0.942871 1.6003V12.3994C0.942871 13.2832 1.65932 13.9997 2.54317 13.9997H7.57433V0H2.54317Z",
    fill: "#FF4B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArabic);
export default __webpack_public_path__ + "static/media/arabic.a31cbdeef14e2c4a4c563e8fe4d3eec9.svg";
export { ForwardRef as ReactComponent };